<template>
    <Suspense>
        <div>
            <RouterView />
            <PopUp />
            <LanguageSelector class="language-selector" />
            <CookiesBanner />
        </div>
    </Suspense>
</template>
<script setup>
import CookiesBanner from '@/js/components/CookiesBanner.vue';
import PopUp from '@/js/components/dashboard/InfoPopUp.vue';
import LanguageSelector from '@/js/components/LanguageSelector.vue';
</script>
<style lang="scss" scoped>
.language-selector {
    position: fixed;
    bottom: 10px;
    left: 10px;
}
</style>
